


































































import Vue from 'vue'
import AppDialogConfirm from '@morpheus/utils/admin-vue/components/AppDialogConfirm.vue'

export default Vue.extend({
  name: 'CurrenciesForm',
  components: {
    AppDialogConfirm
  },
  inject: ['$validator'],
  props: {
    priceAmount: {
      required: true,
      type: Number
    },
    priceCurrency: {
      required: true,
      type: String
    },
    selectedCurrencies: {
      required: true,
      type: Array
    },
    currenciesListArray: {
      required: true,
      type: Array
    },
    index: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      amount: 0,
      currency: '',
      dialogMessage: ''
    }
  },
  watch: {
    amount (amount: number) {
      typeof amount === 'number' && this.$emit('updatePriceCurrencies', amount, this.currency)
    },
    currency (currency: string, oldCurrency: string) {
      typeof this.amount === 'number' && this.$emit('updatePriceCurrencies', this.amount, currency, oldCurrency)
    },
    selectedCurrencies: {
      deep: true,
      handler () {
        this.disableCurrency()
      }
    }
  },
  mounted () {
    this.disableCurrency()
    this.amount = this.priceAmount
    this.currency = this.priceCurrency
  },
  methods: {
    disableCurrency () {
      this.currenciesListArray.forEach((currency: any) => {
        if (this.selectedCurrencies.indexOf(currency.value) !== -1) {
          currency.disabled = true
        } else {
          currency.disabled = false
        }
      })
    },
    removeItem () {
      this.dialogMessage = `Are you sure you want to delete listing currency ${this.currency}?`
    },
    confirmAction (confirmation: boolean) {
      this.dialogMessage = ''

      if (confirmation) {
        this.$emit('onRemoveCurrency', this.currency)
      }
    }
  }
})
